import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { RoleService } from '../services/role.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
class SuperAdminPermissionsService {
  constructor(
    private router: Router, 
    private roleService: RoleService,
    private toastr: ToastrService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Check if the user is a super admin
    if (this.roleService.isSuperAdmin()) {
      return true;
    } else {
      // Show access denied message
      this.toastr.error('You do not have permission to access this page. Super Admin role required.', 'Access Denied');
      
      // Redirect to dashboard
      this.router.navigate(['/admin/dashboard']);
      return false;
    }
  }
}

export const SuperAdminGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(SuperAdminPermissionsService).canActivate(next, state);
}; 